export default __webpack_public_path__ + "static/media/youtube-undraw.7e49ab44.svg";